<template>
  <button class="addbtn">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 12L22 12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M12 2L12 22" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    <span class="addbtn__text"><slot/></span>
  </button>
</template>

<script>
export default {

}
</script>

<style lang="sass" scoped>
.addbtn
  display: flex
  align-items: center
  border: 2px solid colors.$newgray
  filter: drop-shadow(0px 24px 24px rgba(216, 81, 81, 0.16))
  border-radius: 8px
  padding: 13px 32px 14px 14px
  padding-right: 30px
  font-weight: 500
  font-size: 18px
  margin-left: auto
  margin-right: auto
  line-height: 1.36
  width: 328px
  max-width: 100%
  color: colors.$newgray
  cursor: pointer
  letter-spacing: globalvars.$onespacing
  transition: .1s ease-out
  @include adaptiveFont(375, 16, 18)
  &:hover, &:active
    background: colors.$newred
    color: white
    border-color: colors.$newred
  svg
    flex-shrink: 0
    margin-right: 16px
    stroke: currentColor
  &__text
    flex-grow: 1
    text-align: center
    display: inline-block
    transform: translateY(2px)
  @include for-mob
    margin: 32px auto
    &_mobincmargin
      margin: 40px auto
  @include from(500px)
    width: 100%
</style>